var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M11.002 8.36L21.097 0.33C20.782 0.123 20.406 0 20.001 0H2.001C1.614 0 1.255 0.115 0.947998 0.307L11.002 8.36Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.764 1.07589L11.296 9.39089C11.118 9.52489 10.88 9.52489 10.702 9.38989L0.26 1.03589C0.1 1.32289 0.001 1.64789 0 1.99989V12.9999C0.001 14.1029 0.898 14.9999 2.001 14.9999H19.999C21.102 14.9999 21.999 14.1029 22 12.9999V1.99989C22 1.66489 21.91 1.35289 21.764 1.07589Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.4fbeabaeb2a13e46b924f1f8cf81339b.svg";
export { ForwardRef as ReactComponent };